import { Col, Row } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const TruckMutateFormTemplate = () => {
  return (
    <Row>
      <Col xs={12}>
        <CrudPlaceholderInput name="title" />
      </Col>
      <Col xs={12}>
        <CrudPlaceholderInput name="capacity" />
      </Col>
      <Col xs={12}>
        <CrudPlaceholderInput name="width" />
      </Col>
      <Col xs={12}>
        <CrudPlaceholderInput name="length" />
      </Col>
    </Row>
  );
};
